import config from '@/config/prod.env';
import { header } from '@/helper/header';
import { common } from '@/helper/common';

export const baoCaoGiaoDucService = {
    getExportExcel
};

async function getExportExcel(params, tableName) {
    const requestOptions = {
        method: 'POST',
        headers: await header.authHeaderWithToken(),
        body: JSON.stringify(params)
    };

    try {
        // Gửi yêu cầu đến API
        const response = await fetch(`${config.API_URL}/${tableName}/ExportExcel`, requestOptions);

        // Kiểm tra trạng thái phản hồi
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Trả về dữ liệu dạng blob
        return await response.blob();
    } catch (error) {
        console.error("Error fetching export Excel:", error.message);
        throw error; // Ném lỗi để xử lý ở nơi gọi hàm
    }
}
